// import axios from 'axios'
// import React, { useEffect, useState } from 'react'
// import { useHistory, useLocation } from 'react-router-dom'
// import css from '../css/Addcase.module.css'
// import { Link } from 'react-router-dom'
// import Header from '../Components/Header'
// import Rightcontainer from '../Components/Rightcontainer'
// import Swal from 'sweetalert2'
// import socket from '../Components/socket'
// import { useTheme } from '../../ThemeContext'
// import { apiRequest } from '../../apiService/allApi'

// const Redeem = ({ walletUpdate }) => {
//   const history = useHistory()

//   // BASE URL

//   const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const nodeMode = process.env.NODE_ENV;
//   if (nodeMode === "development") {

//     var baseUrl = beckendLocalApiUrl;
//   } else {
//     baseUrl = beckendLiveApiUrl;
//   }
//   // +++++++++++++++++++++++++++++ 

//   const [amount, setamount] = useState()
//   const [userAllData, setUserAllData] = useState()
//   const role = async () => {
//     socket.emit('getprofile')

//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     const res = await apiRequest(`me`, "GET", null, headers)

//     setUserAllData(res.data)

//   }

//   useEffect(() => {
//     let access_token = localStorage.getItem('token')
//     access_token = localStorage.getItem('token')
//     if (!access_token) {
//       window.location.reload()
//       history.push('/login')
//     }
//     role()
//   }, [])

//   const deposit = async () => {
//     if (amount && amount >= 95 && amount <= 100000) {
//       const access_token = localStorage.getItem('token')
//       const headers = {
//         Authorization: `Bearer ${access_token}`
//       }


//       const res = await apiRequest(`referral/to/wallet`, "POST", { amount }, headers)


//       if (res.data.msg === 'Invalid Amount') {
//         Swal.fire({
//           title: "You don't have sufficient amount",
//           icon: 'warning',
//           confirmButtonText: 'OK'
//         })
//       } else {
//         Swal.fire({
//           title: 'success',
//           icon: 'success',
//           confirmButtonText: 'OK'
//         })
//       }
//     } else {
//       let msg = 'Enter Amount'
//       if (!amount) {
//         msg = 'Enter Amount'
//       } else if (95 <= amount <= 100000) {
//         msg = 'Amount should be more than 100.'
//       }
//       Swal.fire({
//         title: msg,
//         icon: 'Error',
//         confirmButtonText: 'OK'
//       })
//     }
//   }

//   // change theme 
//   const theme = localStorage.getItem('theme')
//   const styles = {
//     backgroundColor: theme === 'light' ? '#fff' : 'black',
//     color: theme === 'light' ? 'black' : '#fff',
//   };

//   return (
//     <>
//       <Header user={userAllData} />
//       <div className=" leftContainer redeemPro">

//         {/* TOP HEADER SECTION */}
//         <div className="redeemHeader">
//           {/* <img src="/images/purse.png"  className="headerIcon" /> */}
//           <div>
//             <h2>Redeem Referral Balance</h2>
//             <p>Convert referral balance to KRLUDO Coins</p>
//           </div>
//         </div>

//         {/* MAIN AMOUNT BOX */}
//         <div className="amountHighlight">
//           <img src="/images/purse.png" />

//           {/* IMPORTANT CONTENT INSERTED HERE */}
//           <h3>TDS (0%) will be deducted after earning of ₹15,000</h3>
//           <p className="sub">Minimum withdrawal amount ₹100</p>
//         </div>

//         {/* STATIC BOX */}
//         <div className="badgeItemSolo">
//           <img src="/refer-box.png" />
//           Money will be added to KRLUDO Coin.
//         </div>

//         {/* INPUT LABEL */}
//         <div className="amountLabel">
//           Enter Amount <span>(Min: 100, Max: 10000)</span>
//         </div>

//         {/* INPUT */}
//         <input
//           type="number"
//           value={amount}
//           placeholder="Enter Amount"
//           className="redeemInputFinal"
//           onChange={(e) => setamount(parseInt(e.target.value))}
//         />

//         {/* BUTTON */}
//         <button className="btnRedeemFinal mt-3" onClick={() => deposit()}>
//           Redeem Now
//         </button>

//       </div>


//     </>
//   )
// }
// export default Redeem


import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Header from '../Components/Header'
import Rightcontainer from '../Components/Rightcontainer'
import Swal from 'sweetalert2'
import socket from '../Components/socket'
import { apiRequest } from '../../apiService/allApi'

import {
  Sparkles,
  Coins,
  ArrowRight,
  Gift,
  RefreshCw,
  Wallet
} from "lucide-react";

// import "../css/Redeem.css";

const Redeem = ({ walletUpdate }) => {
  const history = useHistory()

  // BASE URL
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  let baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

  const [amount, setamount] = useState()
  const [userAllData, setUserAllData] = useState()

  const role = async () => {
    socket.emit('getprofile')

    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    const res = await apiRequest(`me`, "GET", null, headers)
    setUserAllData(res.data)
  }

  useEffect(() => {
    let access_token = localStorage.getItem('token')
    if (!access_token) {
      window.location.reload()
      history.push('/login')
    }
    role()
  }, [])

  // Custom SweetAlert for Cyber Emerald Theme
  const showCustomSwal = (title, text, icon) => {
    Swal.fire({
      html: `
        <div class="ce-swal-wrapper">
          <span class="ce-swal-badge">${icon === 'success' ? 'SUCCESS' : 'WARNING'}</span>
          <h2 class="ce-swal-title">${title}</h2>
          <p class="ce-swal-message">${text}</p>
        </div>
      `,
      confirmButtonText: "OK",
      buttonsStyling: false,
      background: "linear-gradient(180deg, #0f172a 0%, #0b0f19 100%)",
      customClass: {
        popup: "ce-swal-popup",
        confirmButton: "ce-swal-confirm-btn"
      }
    });
  };

  const deposit = async () => {
    if (amount && amount >= 95 && amount <= 100000) {
      const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`
      }

      const res = await apiRequest(`referral/to/wallet`, "POST", { amount }, headers)

      if (res.data.msg === 'Invalid Amount') {
        showCustomSwal("Insufficient Balance", "You don't have sufficient amount in your referral wallet.", "warning");
      } else {
        showCustomSwal("Redeemed Successfully", "Referral balance converted into coins!", "success");
      }
    } else {
      let msg = 'Please enter a valid amount.'
      if (!amount) {
        msg = 'Enter Amount'
      } else if (amount < 95 || amount > 100000) {
        msg = 'Amount should be between ₹100 and ₹1,00,000.'
      }
      showCustomSwal("Invalid Amount", msg, "warning");
    }
  }

  // Handle Use Max Button
  const handleUseMax = () => {
    const maxBal = userAllData?.referral_earning || 0;
    setamount(parseInt(maxBal));
  };

  return (
    <>
      <Header user={userAllData} />

      <div className="ce-redeem-wrapper leftContainer mb_space mt-5 pt-5">
        <div className="ce-redeem-container mb-5">
          
          <div className="ce-redeem-card animate-fade">
            
            {/* 1. Hero Referral Wallet Card */}
            <div className="ce-referral-wallet-card">
              <div className="ce-wallet-card-top">
                <div className="ce-card-pill">
                  <Sparkles size={13} className="ce-emerald-icon" />
                  <span>REFERRAL WALLET</span>
                </div>
                <div className="ce-coins-badge">
                  <Coins size={14} className="ce-emerald-icon" />
                  <span>Coins</span>
                </div>
              </div>

              <div className="ce-wallet-balance-center">
                <span className="ce-balance-label">AVAILABLE BALANCE</span>
                <div className="ce-balance-amount">
                  <span className="ce-currency-symbol">₹</span>
                  <span>{userAllData?.referral_earning || 0}</span>
                </div>
                <p className="ce-balance-sub">Convert referral earnings into coins</p>
              </div>
            </div>

            {/* 2. TDS Banner */}
            <div className="ce-tds-banner">
              <Gift size={16} className="ce-emerald-icon" />
              <span>
                <strong>0% TDS</strong> after <strong>₹15,000</strong> yearly earning
              </span>
            </div>

            {/* 3. Input Amount Box */}
            <div className="ce-amount-input-card">
              <div className="ce-input-header-row">
                <span className="ce-input-label">ENTER AMOUNT</span>
                <button
                  type="button"
                  className="ce-use-max-btn"
                  onClick={handleUseMax}
                >
                  Use max
                </button>
              </div>

              <div className="ce-amount-field-wrapper">
                <div className="ce-currency-box">
                  <span>₹</span>
                </div>
                <input
                  type="number"
                  value={amount || ''}
                  placeholder="0"
                  className="ce-amount-field"
                  onChange={(e) => setamount(parseInt(e.target.value))}
                />
                <div className="ce-input-icon-right">
                  <Wallet size={20} />
                </div>
              </div>

              <div className="ce-input-footer-info">
                <span className="ce-limit-text">Min ₹100</span>
                <span className="ce-limit-text">Max ₹1,00,000</span>
              </div>
            </div>

            {/* 4. Converted into Coins Badge */}
            <div className="ce-converted-badge">
              <RefreshCw size={14} className="ce-emerald-icon" />
              <span>Converted into <strong>coins</strong></span>
            </div>

            {/* 5. Redeem Submit Button */}
            <div className="ce-action-btn-area">
              <button
                type="button"
                className="ce-primary-submit-btn"
                onClick={deposit}
              >
                <span>REDEEM NOW</span>
                <ArrowRight size={18} />
              </button>
            </div>

          </div>

        </div>

        <div className="rightContainer mobile-hide">
          <Rightcontainer />
        </div>
      </div>
    </>
  )
}

export default Redeem